(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[829],{

/***/ 78664:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store",
      function () {
        return __webpack_require__(87994);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ LandingFeatureStoreHub; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/feature-store-hub/src/lib/landing-feature-store-hub.module.css
var landing_feature_store_hub_module = __webpack_require__(1000);
var landing_feature_store_hub_module_default = /*#__PURE__*/__webpack_require__.n(landing_feature_store_hub_module);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var ui_src = __webpack_require__(99313);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/hub-intro/hub-intro.tsx



const StoreHubIntro = ({ title , body  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                element: "h2",
                className: (landing_feature_store_hub_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: body
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/hub-intro/index.ts


// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 295 modules
var shared_src = __webpack_require__(88805);
// EXTERNAL MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/store-hub-list/store-hub-list.module.css
var store_hub_list_module = __webpack_require__(37174);
var store_hub_list_module_default = /*#__PURE__*/__webpack_require__.n(store_hub_list_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/assets/chevron-right-icon.tsx

const ChevronRightIcon = ({ size  })=>size === "small" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "22",
        viewBox: "0 0 12 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "chevron-right-small"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.5 1.66658L10.8333 10.9999L1.5 20.3333",
                stroke: "#5234B6",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "chevron-right-large"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.75 1.08329L18.6667 18L1.75 34.9166",
                stroke: "#5234B6",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/assets/location-icon.tsx

const LocationIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "location-icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6569 16.6569C16.7202 17.5935 14.7616 19.5521 13.4138 20.8999C12.6327 21.681 11.3677 21.6814 10.5866 20.9003C9.26234 19.576 7.34159 17.6553 6.34315 16.6569C3.21895 13.5327 3.21895 8.46734 6.34315 5.34315C9.46734 2.21895 14.5327 2.21895 17.6569 5.34315C20.781 8.46734 20.781 13.5327 17.6569 16.6569Z",
                stroke: "#5234B6",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11Z",
                stroke: "#5234B6",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/store-hub-list/store-hub-list.tsx







const StoreCard = (store)=>{
    const { title , address , url  } = store;
    const { cached_url  } = url;
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 1024;
    const cardCategory = "find a cinch store";
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const slug = cached_url.split("/")[1];
    const handleClick = ()=>{
        trackEvent({
            eventName: `cinch stores hub - ${cardCategory}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                action: "select",
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: cardCategory,
                    label: slug
                }
            }
        });
        window.location.assign(`/${cached_url}`);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (store_hub_list_module_default()).cardWrapper,
        onClick: ()=>handleClick(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (store_hub_list_module_default()).detailsSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        element: "h3",
                        className: (store_hub_list_module_default()).subtitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (store_hub_list_module_default()).addressLine,
                        children: [
                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationIcon, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: address
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (store_hub_list_module_default()).chevronIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon, {
                    size: vw < 768 ? "small" : "large"
                })
            })
        ]
    });
};
const StoreHubList = ({ findStoreList  })=>{
    const { title , stores  } = findStoreList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (store_hub_list_module_default()).componentWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                element: "h2",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (store_hub_list_module_default()).listWrapper,
                children: stores.map((store, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(StoreCard, {
                        ...store
                    }, `store-card-${index}`))
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/store-hub-list/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/cta/cta.module.css
var cta_module = __webpack_require__(25760);
var cta_module_default = /*#__PURE__*/__webpack_require__.n(cta_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/cta/cta.tsx




const Cta = ({ cta  })=>{
    const { title , body , ctaText  } = cta;
    const ctaCategory = "happy to travel to any cinch store?";
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const allStoresPath = "used-cars?store=all-stores";
    const handleClick = ()=>{
        trackEvent({
            eventName: `cinch stores hub - ${ctaCategory}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                action: "select",
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: ctaCategory,
                    label: "search all cinch store cars"
                }
            }
        });
        window.open(allStoresPath, "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (cta_module_default()).ctaWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (cta_module_default()).textWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        element: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                href: allStoresPath,
                onClick: ()=>handleClick(),
                children: ctaText
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/cta/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/content-with-image-section/content-with-image-section.module.css
var content_with_image_section_module = __webpack_require__(79411);
var content_with_image_section_module_default = /*#__PURE__*/__webpack_require__.n(content_with_image_section_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/content-with-image-section/content-with-image-section.tsx





const ContentWithImageSection = ({ title , body , image  })=>{
    const { filename , alt  } = image;
    const imageUrl = (0,src/* getStoryblokImageServiceUrl */.Vb)(filename, {
        filters: [
            {
                quality: 70
            }
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (content_with_image_section_module_default()).sectionWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        className: (landing_feature_store_hub_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: imageUrl,
                alt: alt ? alt : "",
                className: (content_with_image_section_module_default()).sectionImage
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/content-with-image-section/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/how-stores-work/how-stores-work.module.css
var how_stores_work_module = __webpack_require__(17908);
var how_stores_work_module_default = /*#__PURE__*/__webpack_require__.n(how_stores_work_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/how-stores-work/how-stores-work.tsx




const HowStoresWork = ({ howStoresWork  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (how_stores_work_module_default()).howStoresWork,
        children: howStoresWork.map((section)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWithImageSection, {
                title: section.title,
                body: (0,shared_src/* renderWithResolver */.be)(section.body),
                image: section.image
            }, section.title))
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/components/how-stores-work/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/landing-feature-store-hub.tsx









function LandingFeatureStoreHub({ story , preview , generatedAt  }) {
    var ref;
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    const { intro , findStore , howStoresWork , cta  } = content;
    const introTitle = intro[0].title;
    const introBody = (0,shared_src/* renderWithResolver */.be)(intro[0].body);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "cinch store | Buy a car in person",
                fallbackDescription: "Drop into a cinch store to buy a car, faff-free and in person. See, touch and test-drive your next car at your closest cinch store."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_store_hub_module_default()).storeHubIntroWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreHubIntro, {
                            title: introTitle,
                            body: introBody
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_store_hub_module_default()).sectionWrapper
                        },
                        isSlim: true,
                        backgroundColor: "#F2F5FF",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreHubList, {
                            findStoreList: findStore[0]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        className: {
                            container: (landing_feature_store_hub_module_default()).howStoresWorkWrapper
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowStoresWork, {
                            howStoresWork: howStoresWork
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        backgroundColor: "#ECF5F9",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cta, {
                            cta: cta[0]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var landing_feature_store_hub = ((/* unused pure expression or super */ null && (LandingFeatureStoreHub)));

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/lib/get-static-props.ts


const getStaticPropsfn = async ({ preview =false  })=>{
    try {
        const story = await (0,src/* getStoryBySlug */.OI)(`store`, {
            version: preview ? "draft" : "published"
        });
        if (!story) {
            throw new Error("Store information story not found");
        }
        const heroProps = {
            ...story.content.hero[0]
        };
        return {
            props: {
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    showBorderRadius: true,
                    heroProps
                }
            },
            revalidate: 60
        };
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            console.log(error);
        }
        return {
            notFound: true
        };
    }
};
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("store-page.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-store-hub/src/index.ts



;// CONCATENATED MODULE: ./pages/store/index.tsx
var __N_SSG = true;



/***/ }),

/***/ 79411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"content-with-image-section_sectionWrapper__ettSK","sectionImage":"content-with-image-section_sectionImage__QL7BS"};

/***/ }),

/***/ 25760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"cta_ctaWrapper__gCAr_","textWrapper":"cta_textWrapper__cHxCH"};

/***/ }),

/***/ 17908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"howStoresWork":"how-stores-work_howStoresWork__V_w_5"};

/***/ }),

/***/ 37174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"store-hub-list_componentWrapper__SZGNm","listWrapper":"store-hub-list_listWrapper__viFHn","cardWrapper":"store-hub-list_cardWrapper__nQTeo","detailsSection":"store-hub-list_detailsSection__FU_ve","subtitle":"store-hub-list_subtitle__ld2Sx","addressLine":"store-hub-list_addressLine___4Jcp","chevronIcon":"store-hub-list_chevronIcon__9SOqG"};

/***/ }),

/***/ 1000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"landing-feature-store-hub_sectionWrapper__ns_S5","title":"landing-feature-store-hub_title__WEpwq","storeHubIntroWrapper":"landing-feature-store-hub_storeHubIntroWrapper__Sx3Jf","howStoresWorkWrapper":"landing-feature-store-hub_howStoresWorkWrapper__lqhDx"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(78664); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);